module.exports = __webpack_public_path__ + "media/images/gifts/cook/sug_cozinhar_5-123606f4c858e90050531ae14f486b57.jpg";